module.exports = __webpack_public_path__ + "img/gb9114_2_b.prt.638a3ad1.jpg";